module.exports = __webpack_public_path__ + "static/media/simplepay_bankcard_logos_left-hu.075ad901.png";